import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import TopBar from './TopBar';
import Navbar from './Navbar';
import MobileMenu from './MobileMenu';
import './Header.css';

export default function Header({ cartCount = 0 }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return undefined;

    const animation = gsap.context(() => {
      const timeline = gsap.timeline({ defaults: { ease: 'power3.out' } });
      timeline
        .from('.top-bar', { autoAlpha: 0, y: -18, duration: .45 })
        .from('.navbar', { autoAlpha: 0, y: -22, duration: .6 }, '-=.25')
        .from('.brand', { autoAlpha: 0, scale: .88, duration: .5 }, '-=.35')
        .from('.nav-item', { autoAlpha: 0, y: -10, duration: .35, stagger: .06 }, '-=.3')
        .from('.header-actions > *', { autoAlpha: 0, x: 12, duration: .35, stagger: .08 }, '-=.35');
    }, headerRef);

    return () => animation.revert();
  }, []);

  return <header className="site-header" ref={headerRef}>
    <TopBar />
    <Navbar cartCount={cartCount} mobileOpen={mobileOpen} onMenuToggle={() => setMobileOpen(value => !value)} />
    <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} />
  </header>;
}
